import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";

export async function getFile(
    fileID,
    {FarmID, ClientID, LocalUserID, disposition} = {}
) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    const queryParams = {
        FileID: fileID,
    };

    if (disposition) {
        queryParams.disposition = disposition;
    }

    let res = await invokeApig({
        ...Paths.getFile({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        queryParams,
    });
    return res.ResourceUrl;
}
